import React from "react"
import { NewExhibitorPersonForm } from '../NewExhibitorPersonForm.jsx';
import { NewExhibitorCompanyForm } from '../NewExhibitorCompanyForm.jsx';
import { ErrorMessage } from '../../shared/ErrorMessage.jsx';
import I18n from 'i18n-js';
import '../../translations.js';

export class NewExhibitor extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div>
        { this.props.type == "person" ? 
          <h1>{I18n.t("exhibitor.new_exhibtor_person")}</h1> :
          <h1>{I18n.t("exhibitor.new_exhibtor_company")}</h1>
        }
        <div className="row">
          <div className="span12">
            { this.props.type == "person" ? 
              <NewExhibitorPersonForm provincess={this.props.createUserData.provincess}
                         type={this.props.type}
                         userData={this.props.userData}
                         usef={this.props.usef}
                         ec={this.props.ec}
                         fei={this.props.fei} />
              : 
              <NewExhibitorCompanyForm provincess={this.props.createUserData.provincess}
                         type={this.props.type}
                         userData={this.props.userData}
                         usef={this.props.usef}
                         ec={this.props.ec}
                         fei={this.props.fei} />
            }
          </div>
        </div>
        <p>
          <b>{ I18n.t("mandatory_field")}</b>
        </p>
        <ErrorMessage message={ I18n.t("exhibitor.fill_out_fields") } />
      </div>
    );
  }
};

